import {Component, inject} from '@angular/core';
import {Router} from '@angular/router';
import {AsyncPipe} from '@angular/common';
import {TranslatePipe} from '@ngx-translate/core';
import {MatButton} from '@angular/material/button';
import {MatMenu, MatMenuItem, MatMenuTrigger} from '@angular/material/menu';
import {MatIcon} from '@angular/material/icon';
import {AuthService} from '../../auth/auth.service';
import {CoreService} from '../core.service';
import {MenuItem} from '../classes/menu-item';

/**
 * Top-right user menu (audit C18). An avatar + name/role button that opens a
 * dropdown of the account actions (Profilo / Pagamenti / Aiuto / Logout) sourced
 * from `CoreService.userMenu$`. Replaces the old in-sidebar user expansion panel;
 * lives at the right end of the sidenav-content toolbar.
 */
@Component({
  selector: 'nbd-user-menu',
  templateUrl: './user-menu.component.html',
  styleUrl: './user-menu.component.scss',
  imports: [MatButton, MatMenu, MatMenuItem, MatMenuTrigger, MatIcon, AsyncPipe, TranslatePipe],
})
export class UserMenuComponent {
  protected auth = inject(AuthService);
  protected cs = inject(CoreService);
  private router = inject(Router);

  /** Mirror nav-menu-item's click: run the item action (e.g. logout), then route. */
  select(m: MenuItem): void {
    m.onClick?.();
    if (m.url) {
      this.router.navigate([m.url]);
    }
  }
}
